/**
 *  Standard paging composition for employees
 */
import employeeActionCreators from '../../../actions/employeeActionCreators';
import pagingComposition from '../../common/pagingTable/pagingComposition';
export default pagingComposition(
// these are specific to documents.
'employee',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
employeeActionCreators, {
  'Employee Number': 'employeeNumber',
  Name: 'name'
});